export const CHANGE_AUTH_STATE = 'CHANGE_AUTH_STATE';
export const SET_DATA = 'SET_DATA';
export const TOGGLE_RECEIVER = 'TOGGLE_RECEIVER';
export const ADD_GROUP_ACCESS = 'ADD_GROUP_ACCESS';
export const REMOVE_GROUP_ACCESS = 'REMOVE_GROUP_ACCESS';
export const CLEAR_GROUP_ACCESS = 'CLEAR_GROUP_ACCESS';
export const ADD_USER = 'ADD_USER';
export const CHANGE_USER_NAME = 'CHANGE_USER_NAME';
export const REMOVE_USER = 'REMOVE_USER';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export function addGroupAccess(groupAccess){
    return {type: ADD_GROUP_ACCESS, payload: {groupAccess}};
}

export function removeGroupAccess(groupAccess){
    return {type: REMOVE_GROUP_ACCESS, payload: {groupAccess}};
}

export function clearGroupAccess(){
    return {type: CLEAR_GROUP_ACCESS};
}

export function changeAuthState(authState){
    return {type: CHANGE_AUTH_STATE, payload: {authState}};
}

export function setData(data){
    return {type: SET_DATA, payload: {data}};
}

export function toggleReceiver(receiver, checked){
    return {type: TOGGLE_RECEIVER, payload: {receiver, checked}};
}

export function changeUserName(login, userName, type){
    return {type: CHANGE_USER_NAME, payload: {login, userName, type}};
}

export function removeUser(login, type){
    return {type: REMOVE_USER, payload: {login, type}};
}

export function addUser(login, userName, type){
    return {type: ADD_USER, payload: {login, userName, type}};
}

export function updateGroup(login, groupName){
    return {type: UPDATE_GROUP, payload: {login, groupName}};
}

export function setError(error){
    return {type: SET_ERROR, payload: {error}};
}

export function clearError(){
    return {type: CLEAR_ERROR};
}


// WEBPACK FOOTER //
// ./src/actions.js